export default __webpack_public_path__ + "static/media/i075jp.919a94b1.webp";